import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { createVendor } from "../../services/VendorServices";
import BarLoader from "../../components/Loader/BarLoader";
import { useNavigate } from "react-router-dom";

const userValidationSchema = Yup.object({
  name: Yup.string().required("Vendor Name is required"),
});

function AddVendor({ name, showModal, setShowModal, onVendorAdded }) {
  const [creating, setCreating] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(userValidationSchema),
    defaultValues: {
      name: "",
      contactPersonName: "",
      email: "",
      mobileNumber: "",
      address: "",
    },
  });
  const handleDiscard = () => {
    setShowModal(false);
    reset();
  };
  useEffect(() => {
    reset((prev) => ({
      ...prev,
      name: name || "",
    }));
  }, [name, reset]);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const payload = {
        name: data.name,
        contact_person_name: data.contactPersonName,
        email: data.email,
        mobile_number: data.mobileNumber,
        address: data.address,
      };
      setCreating(true);
      const response = await createVendor(payload);

      toast.success("Vendor created successfully");

      if (onVendorAdded) {
        onVendorAdded(response.data);
      }

      reset();
      setShowModal(false);

      // Redirect to /vendors after success
      navigate("/vendors");
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to create user");
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal show={showModal} onHide={handleDiscard}>
      <Modal.Header closeButton>
        <Modal.Title>Add Vendor Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="name">Vendor Name</Form.Label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      type="text"
                      placeholder="Enter Vendor Name"
                      style={{ resize: "both" }}
                      isInvalid={!!errors.name}
                      {...field}
                    />
                  )}
                />
                {errors.name?.message && (
                  <div className="text-danger small">
                    {errors.name?.message}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="contactPersonName">
                  Conatct Person
                </Form.Label>
                <Controller
                  name="contactPersonName"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      type="text"
                      placeholder="Enter Contact Person Name"
                      isInvalid={!!errors.lastName}
                      {...field}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="email">Email</Form.Label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      type="text"
                      placeholder="Enter email"
                      isInvalid={!!errors.email}
                      {...field}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label htmlFor="mobileNumber">Mobile Number</Form.Label>
                <Controller
                  name="mobileNumber"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      type="text"
                      placeholder="Enter Mobile Number"
                      isInvalid={!!errors.mobileNumber}
                      {...field}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Controller
                  name="address"
                  control={control}
                  render={({ field }) => (
                    <Form.Control
                      as="textarea"
                      rows={2}
                      placeholder="Enter address"
                      isInvalid={!!errors.address}
                      {...field}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mt-4">
            <Button
              variant="outline-danger"
              className="me-2"
              onClick={handleDiscard}
            >
              Discard
            </Button>
            <Button type="submit" variant="primary" disabled={creating}>
              {creating ? <BarLoader /> : "Submit"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default AddVendor;
